var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_vm._v(" test "),_c('v-btn',{on:{"click":_vm.print}},[_vm._v("Print")]),_c('iframe',{attrs:{"id":"printf","src":"/receipt","frameborder":"0","height":"812px","width":"375"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }